module.exports = __webpack_public_path__ + "static/media/sad_face.6e958f63.png";